import { createFileRoute } from "@tanstack/react-router";

import { loadContracts } from "../contracts/loaders.ts";
import { ContractsPending } from "../contracts/pending.tsx";
import { RegisterPage } from "../contracts/register-page.tsx";
import { useViewer } from "../data/hooks.ts";
import { isSectionShown, sections } from "../shell/navigation.ts";
import { contractsSearch, retainPropertyFilter } from "../shell/search.ts";
import { NotFoundPage } from "../shell/status-pages.tsx";

import type { ReactElement } from "react";

// WHY: contracts are confidential: below manager the route answers not found (27-contracts → States), never "no access".
const Page = (): ReactElement => {
  const viewer = useViewer();
  return viewer === null || !isSectionShown(sections.contracts, viewer.role) ? (
    <NotFoundPage />
  ) : (
    <RegisterPage viewer={viewer} />
  );
};

export const Route = createFileRoute("/_app/contracts/")({
  staticData: { hasPropertyContext: true },
  validateSearch: contractsSearch,
  search: retainPropertyFilter(),
  loader: async ({ context }) => loadContracts(context.data),
  pendingComponent: ContractsPending,
  component: Page,
});
